import React, { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import OurStorySection from './components/OurStorySection';
import MasterySection from './components/MasterySection';
import IndustriesSection from './components/IndustriesSection';
import HowWeWorkSection from './components/HowWeWorkSection';

const AboutPage = () => {
  useEffect(() => {
    // Set page title
    document.title = 'About Mirakalous Technologies Inc. | Practical, Production‑Grade AI';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 'Mirakalous builds practical, production‑grade AI for regulated and high‑stake environments. We specialize in on‑prem and private‑cloud deployments where data sovereignty, safety, and auditability matter as much as accuracy and speed.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Mirakalous builds practical, production‑grade AI for regulated and high‑stake environments. We specialize in on‑prem and private‑cloud deployments where data sovereignty, safety, and auditability matter as much as accuracy and speed.';
      document.getElementsByTagName('head')?.[0]?.appendChild(meta);
    }

    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      
      <main className="pt-16">
        {/* Hero Section */}
        <HeroSection />

        {/* Our Story */}
        <OurStorySection />

        {/* Mastery */}
        <MasterySection />

        {/* Industries */}
        <IndustriesSection />

        {/* How We Work */}
        <HowWeWorkSection />
      </main>
      {/* Footer removed in favor of global footer */}
    </div>
  );
};

export default AboutPage;